import React, { ReactNode, useState } from 'react';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

export type ModalContent = { title: string; body: string };

interface ModalProps {
	trigger?: (openModal: () => void) => ReactNode;
	content: ModalContent[];
	image?: ReactNode;
	centreTitle?: boolean;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function Modal(props: ModalProps) {

	// state.
	const defaultOpen = !props.trigger;
	const [isOpen, setIsOpen] = useState(defaultOpen);
	const [currentItemIndex, setCurrentItemIndex] = useState(0);

	// handlers.

	const openModal = () => {
		setIsOpen(true);
	}

	const closeModal = () => {
		setIsOpen(false);
		setTimeout(() => {
			setCurrentItemIndex(0);
		}, 300);
	}

	const handleNext = () => {
		setCurrentItemIndex(prevState => prevState - 1);
	}

	const handlePrev = () => {
		setCurrentItemIndex(prevState => prevState + 1);
	}

	// return the HTML.
	return (
		<React.Fragment>
			{props.trigger && props.trigger(openModal)}
			<div onClick={(e: React.MouseEvent) => e.stopPropagation()} id="modal-container" className={isOpen ? 'open' : ''}>
				<div id="modal-body">
					{props.image}
					<div id="modal-text">
						<p id="modal-title" style={{ textAlign: props.centreTitle ? 'center' : 'left' }}>{props.content[currentItemIndex]?.title}</p>
						<p dangerouslySetInnerHTML={{ __html: props.content[currentItemIndex].body }}></p>

						{props.content.length > 0 && (
							<div id="modal-footer">
								{currentItemIndex > 0 && (
									<button className="summary-button" onClick={handleNext}>
										<img alt="<" src={'assets/images/icons/up-arrow.svg'} /> BACK
									</button>
								)}
								{currentItemIndex < props.content.length - 1 && (
									<button id="next" className="summary-button" onClick={handlePrev}>
										NEXT <img alt=">" src={'assets/images/icons/down-arrow.svg'} />
									</button>
								)}
							</div>
						)}
						<div className="close-icon" onClick={closeModal}>
							<img src="assets/images/icons/close.svg" width="35" height="35" alt="Close" />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}
